import React from 'react';
import { Bell, BellOff, Share, SquarePlus } from 'lucide-react';
import { usePushNotifications } from '../../hooks/usePushNotifications';

const PushToggle: React.FC = () => {
  const { support, subscribed, busy, error, subscribe, unsubscribe } = usePushNotifications();

  if (support === 'unsupported') return null;

  return (
    <div className="mb-4 rounded-xl border border-line bg-surface-raised p-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-medium">Push notifications</p>
          <p className="mt-0.5 text-xs text-content-secondary">
            {support === 'needs-install'
              ? 'Available once the app is on your Home Screen.'
              : 'Get the reminder straight to your device — no email needed.'}
          </p>
        </div>

        {support === 'supported' && (
          <button
            type="button"
            onClick={subscribed ? unsubscribe : subscribe}
            disabled={busy}
            aria-pressed={subscribed}
            className={`inline-flex min-h-11 shrink-0 items-center gap-2 rounded-lg px-3 text-sm font-medium transition disabled:opacity-50 ${
              subscribed
                ? 'bg-surface-sunken text-content-secondary hover:text-content'
                : 'bg-inverse text-inverse-content hover:opacity-90'
            }`}
          >
            {subscribed ? <BellOff size={16} aria-hidden /> : <Bell size={16} aria-hidden />}
            {busy ? 'Working…' : subscribed ? 'Turn off' : 'Enable'}
          </button>
        )}
      </div>

      {support === 'needs-install' && (
        <p className="mt-2 text-xs text-content-secondary">
          Tap <Share size={12} className="inline align-[-1px]" aria-label="Share" /> then{' '}
          <span className="whitespace-nowrap font-medium text-content">
            Add to Home Screen <SquarePlus size={12} className="inline align-[-1px]" aria-hidden />
          </span>
          , then reopen from your Home Screen.
        </p>
      )}

      {error && (
        <p role="alert" className="mt-2 text-xs text-red-700 dark:text-red-300">
          {error}
        </p>
      )}
    </div>
  );
};

export default PushToggle;
